import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { getFuncionario, updateFuncionario } from '../../api/funcionarios';

export default function FuncionarioEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ nome: '', data_nascimento: '', sexo: '' });
  const [cpf, setCpf] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    getFuncionario(id)
      .then((f) => {
        setForm({ nome: f.nome || '', data_nascimento: f.data_nascimento || '', sexo: f.sexo || '' });
        setCpf(f.cpf || '');
      })
      .catch(() => setError('Erro ao carregar dados do funcionário'))
      .finally(() => setLoading(false));
  }, [id]);

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSaving(true);
    try {
      await updateFuncionario(id, {
        nome: form.nome,
        data_nascimento: form.data_nascimento || null,
        sexo: form.sexo || null,
      });
      navigate(`/funcionarios/${id}`);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao salvar');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <>
      <button className="btn btn-sm btn-link text-muted mb-3 ps-0" onClick={() => navigate(`/funcionarios/${id}`)}>
        <i className="bi bi-arrow-left me-1"></i>Voltar para perfil
      </button>

      <PageHeader title="Editar funcionário" subtitle={`CPF: ${cpf}`} />

      <div className="card-datafit p-4" style={{ maxWidth: 560 }}>
        {error && (
          <div className="alert alert-danger py-2 small mb-3">
            <i className="bi bi-exclamation-triangle me-2"></i>{error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label small fw-500">Nome completo *</label>
            <input type="text" className="form-control" value={form.nome} onChange={set('nome')} required />
          </div>

          <div className="row g-3 mb-4">
            <div className="col-sm-6">
              <label className="form-label small fw-500">Data de nascimento</label>
              <input type="date" className="form-control" value={form.data_nascimento} onChange={set('data_nascimento')} />
            </div>
            <div className="col-sm-6">
              <label className="form-label small fw-500">Sexo</label>
              <select className="form-select" value={form.sexo} onChange={set('sexo')}>
                <option value="">Selecione</option>
                <option value="M">Masculino</option>
                <option value="F">Feminino</option>
              </select>
            </div>
          </div>

          <div className="d-flex gap-2">
            <button type="submit" className="btn-datafit" disabled={saving}>
              {saving ? <span className="spinner-border spinner-border-sm me-2" /> : <i className="bi bi-check-lg me-2"></i>}
              Salvar
            </button>
            <button type="button" className="btn btn-outline-secondary" onClick={() => navigate(`/funcionarios/${id}`)}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
